import React from 'react';

import styles from './empty-page.scss';

interface Props {
  iconSrc: any;
  iconWithoutBackground?: boolean;
  width?: number;
}

export const Image = ({
  iconSrc,
  iconWithoutBackground = false,
  width = 60,
}: Props) => {
  if (iconWithoutBackground) {
    return <img src={iconSrc} />;
  }

  return (
    <div className={styles.imageArea}>
      <img src={iconSrc} width={width} />
    </div>
  );
};
